// Tuning + offset-delta mutation hooks (tuning.rs).
//   PATCH /v1/screens/{id}/tuning, POST /v1/screens/{id}/offset {deltaMinutes}
// Both recompute the estimate server-side and return displayedMinutes, so
// both invalidate the screen detail cache.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "./http";
import { screenKeys } from "./keys";
import type { OffsetResponse, PatchTuning, TuningResponse } from "./types";

export function usePatchTuning(screenId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body: PatchTuning) => http.patch<TuningResponse>(`/v1/screens/${screenId}/tuning`, { json: body }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: screenKeys.detail(screenId) });
        },
    });
}

export function useOffsetDelta(screenId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (deltaMinutes: number) =>
            http.post<OffsetResponse>(`/v1/screens/${screenId}/offset`, { json: { deltaMinutes } }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: screenKeys.detail(screenId) });
        },
    });
}
